import { DashboardSummaryResponse } from "@idw-types/data/dashboard";
import { isNullOrUndefined } from "@utils/object-util";
import { CardContainer } from "../../common/card-container/card-container";
import styles from "./dashboard-summary-container.less";

type DashboardSummaryContainerProps = {
    dashboardSummary: DashboardSummaryResponse;
};

export const DashboardSummaryContainer = (props: DashboardSummaryContainerProps) => {
    const { dashboardSummary } = props;
    const idPrefix = 'dashboard-summary';
    return (
        <div className={styles.dashboardSummaryContainer}>
            {!isNullOrUndefined(dashboardSummary.relyingPartyCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-relying-party-count`} className={styles.summaryData}>{dashboardSummary.relyingPartyCount}</span>
                    <span className={styles.summaryTitle}>Relying Parties</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.serviceCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-service-count`} className={styles.summaryData}>{dashboardSummary.serviceCount}</span>
                    <span className={styles.summaryTitle}>Verification Services</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.transactionCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-transaction-count`} className={styles.summaryData}>{dashboardSummary.transactionCount}</span>
                    <span className={styles.summaryTitle}>Total transactions</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.policyObligationCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-policy-obligation-count`} className={styles.summaryData}>{dashboardSummary.policyObligationCount}</span>
                    <span className={styles.summaryTitle}>Obligations</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.averageScore) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-average-score-count`} className={styles.summaryData}>{dashboardSummary.averageScore}</span>
                    <span className={styles.summaryTitle}>Average Trust Score</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.policyApprovalCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span  id={`${idPrefix}-policy-approval-count`}className={styles.summaryData}>{dashboardSummary.policyApprovalCount}</span>
                    <span className={styles.summaryTitle}>Verified Users</span>
                </CardContainer>
            )}
            {!isNullOrUndefined(dashboardSummary.policyRejectionCount) && (
                <CardContainer className={styles.summaryCard}>
                    <span id={`${idPrefix}-policy-rejection-count`} className={styles.summaryData}>{dashboardSummary.policyRejectionCount}</span>
                    <span className={styles.summaryTitle}>Risky Transactions Blocked</span>
                </CardContainer>
            )}
        </div>
    )
};